import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import { I18n } from 'react-i18next'
import './eZpayTopUp.css';
import SubmitButton from "../../../../../03-components/ModalSubmitButton";

export default class EZPayEnterSgpPassword extends Component {
    state = {
        sgpPassword: '',
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isSubmitting && !nextProps.isSubmitting) {
            this.setState({ sgpPassword: '' });
        }
    }

    refreshInputAndToggle = () => {
        this.setState({ sgpPassword: '' });
        this.props.toggle();
    };

    onTextChange = e => this.setState({ sgpPassword: e.target.value });

    onSubmit = () => {
        const { sgpPassword } = this.state;
        this.props.onConfirmSgpPassword({ sgpPassword });
    };

    render() {
        const { isOpen, isSubmitting } = this.props;
        const { sgpPassword } = this.state;
        return (
            <I18n ns="translations">
                {
                    t => (
                        <Modal isOpen={isOpen} contentClassName="transfer-to-card-border">
                            <div className='transfer-to-card'>
                                <div className='transfer-to-card-title text-black'>
                                    <span className='text-size-18'>{t('transfer_to_card')}</span>
                                    <button type="button" onClick={this.refreshInputAndToggle} className='close' aria-label='Close'>
                                        <span aria-hidden="true">{"×"}</span>
                                    </button>
                                </div>
                                <div className='sgp-authorize-body'>
                                    <div className="select-application-id-wrapper">
                                        <p className="text-center enter-sgp-password-intro">{t('enter_your_sgp_password')}</p>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <input
                                                    name="password"
                                                    type="password"
                                                    className="form-control sgp-password-input"
                                                    value={sgpPassword}
                                                    onChange={this.onTextChange}
                                                />
                                            </div>
                                        </div>
                                        <div className='text-center'>
                                            <SubmitButton
                                                className="btn btn-primary btn-fw select-application-id-button"
                                                onClick={this.onSubmit}
                                                isSubmitting={isSubmitting}
                                                disabled={!sgpPassword}
                                                text={t('confirm')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    )
                }
            </I18n>
        );
    }
}
